/* eslint-disable react/require-default-props */
import React from 'react';
import CSSModules from 'react-css-modules';
import styles from './index.styl';

const Line = () => {
  return <div styleName="root" />;
};

export default CSSModules(Line, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/Line/index.jsx